import React, { useEffect, useState,useContext } from 'react';
import {
  Container, Typography, Card, CardContent, Table, TableHead, TableRow, TableCell, TableBody,
  Stack, IconButton, Button, Grid, Badge
} from '@mui/material';
import { Visibility, Edit } from '@mui/icons-material';
import studioApi from '../../api/studioApi';
import documentoApi from '../../api/documentoApi';
import contribuenteApi from '../../api/contribuenteApi';
import filesApi from '../../api/filesApi';
import { useParams, useNavigate } from 'react-router-dom';
import { formatDate } from '../../utils/dateFormatter';
import { AuthContext } from '../../auth/AuthContext';

export default function DashboardStudioDesktop() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const [studio, setStudio] = useState(null);
  const [documenti, setDocumenti] = useState([]);
  const [totContribuenti, setTotContribuenti] = useState(0);
  const [scadenzeProssime, setScadenzeProssime] = useState(0);
  const [scadenzeScadute, setScadenzeScadute] = useState(0);
  const [totDocumenti, setTotDocumenti] = useState(0);
  const [totRateSaltate, setTotRateSaltate] = useState(0);

  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const pageSize = 10;
  const pageSizeContribuenti=10000;

  useEffect(() => {
    fetchStudio();
    fetchContribuenti(0);
    fetchDocumenti(0);
  }, [id]);

  const fetchStudio = () => {
    studioApi.get(id)
      .then(r => setStudio(r.data))
      .catch(err => console.error('Errore caricamento studio:', err));
  };

  const fetchContribuenti = async (page) => {
    try {
      console.log("userId",user.userId);
      const res = await contribuenteApi.listbystudio(id, { page, size: pageSizeContribuenti });
      //const contribuenti = res.data.content || [];
      console.log("contribuenti",res.data.content);
      const totContribuenti=res.data.content.length;
      // Calcolo KPI
      setTotContribuenti(totContribuenti);
      console.log("totContribuenti",totContribuenti);
    } catch(err) {
      console.error('Errore caricamento documenti:', err);
    }
  };

  const fetchDocumenti = async (page) => {
    try {
      console.log("userId",user.userId);
      const res = await documentoApi.listbystudio(user.userId, { page, size: pageSize });
      const docs = res.data.content || [];

      // Calcolo KPI
      let totDocs = 0, totRates = 0, prossime = 0, scadute = 0;
      docs.forEach(d => {
        totDocs++;
        totRates += d.rateSaltate || 0;
        d.scadenze?.forEach(s => {
          const today = new Date();
          const dataScad = new Date(s.data);
          const diff = (dataScad - today) / (1000*60*60*24);
          if(diff >=0 && diff <=7) prossime++;
          if(diff <0) scadute++;
        });
      });

      setDocumenti(docs);
      setTotalPages(res.data.totalPages || 0);
      setPage(res.data.number || 0);
      setTotDocumenti(totDocs);
      setTotRateSaltate(totRates);
      setScadenzeProssime(prossime);
      setScadenzeScadute(scadute);
    } catch(err) {
      console.error('Errore caricamento documenti:', err);
    }
  };

  const openPdf = async (filename) => {
    try {
      const response = await filesApi.getfile(filename);
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch(err) {
      console.error(err);
      alert("Impossibile aprire il PDF");
    }
  };

  if(!studio) return <div>Loading...</div>;

  return (
    <Container>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Dashboard Studio: {studio.username || studio.nome}
      </Typography>

      {/* KPI CARD */}
      <Grid container spacing={2} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography variant="subtitle2">Contribuenti</Typography>
            <Typography variant="h5">{totContribuenti}</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography variant="subtitle2">Documenti totali</Typography>
            <Typography variant="h5">{totDocumenti}</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography variant="subtitle2">Rate saltate</Typography>
            <Typography variant="h5">{totRateSaltate}</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography variant="subtitle2">Scadenze prossime (&lt;7 giorni)</Typography>
            <Typography variant="h5">{scadenzeProssime}</Typography>
          </CardContent></Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card><CardContent>
            <Typography variant="subtitle2">Scadenze scadute</Typography>
            <Typography variant="h5">{scadenzeScadute}</Typography>
          </CardContent></Card>
        </Grid>
      </Grid>

      {/* CARD STUDIO */}
      <Card sx={{ mt: 2 }}><CardContent>
        <Typography>Tipo contratto: {studio.contratto?.tipocontratto?.tipo || '—'}</Typography>
        <Typography>Canone annuo contratto: {studio.contratto?.canoneAnnuo || '—'}</Typography>
        <Typography>Scadenza contratto: {studio.contratto?.dataFine || '—'}</Typography>
      </CardContent></Card>

      {/* TABELLA DOCUMENTI */}
      <Typography variant="h6" sx={{ mt: 3 }}>Documenti recenti</Typography>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Tipo</TableCell>
            <TableCell>Descrizione</TableCell>
            <TableCell>Contribuente</TableCell>
            <TableCell>P.IVA</TableCell>
            <TableCell>Rate saltate</TableCell>
            <TableCell>PDF</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {documenti.map(d => (
            <TableRow key={d.id}>
              <TableCell>{d.tipo}</TableCell>
              <TableCell>{d.descrizione}</TableCell>
              <TableCell>{d.contribuente?.nome} {d.contribuente?.cognome}</TableCell>
              <TableCell>{d.contribuente?.partitaIVA}</TableCell>
              <TableCell>{d.rateSaltate > 0 ? <Badge color="error" badgeContent={d.rateSaltate}><span/></Badge> : 0}</TableCell>
 <TableCell>
   {d.pdfPath ? (
     <Button
       variant="outlined"
       size="small"
       onClick={async () => {
         try {
           const res = await filesApi.getfile(d.pdfPath);
           const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
           window.open(url, '_blank');
         } catch (err) {
           console.error('Errore apertura PDF:', err);
         }
       }}
     >
       Apri
     </Button>
   ) : (
     'Nessuno'
   )}
 </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* PAGINAZIONE */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button key={i} variant={i === page ? 'contained' : 'outlined'} onClick={() => fetchDocumenti(i)}>
            {i + 1}
          </Button>
        ))}
      </Stack>
    </Container>
  );
}